import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20compositions%20with%20warm%20terracotta%20and%20cream%20tones%2C%20overlapping%20translucent%20shapes%20creating%20depth%2C%20minimal%20modern%20design%20with%20soft%20gradients%2C%20artistic%20background%20for%20content%20navigation%20website%2C%20clean%20and%20elegant%20atmosphere%2C%20high%20quality%20abstract%20wallpaper%20style&width=1800&height=900&seq=hero-bg-zone-2026&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/20 mb-8">
          <i className="ri-sparkling-2-line text-accent-300 text-sm"></i>
          <span className="text-xs md:text-sm text-background-100 font-medium">最全面的一区二区三区导航指南</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-6 leading-tight">
          一区二区三区
          <br />
          <span className="text-accent-300">完整导航指南</span>
        </h1>

        <p className="text-sm md:text-lg text-background-200 max-w-2xl mx-auto mb-10 leading-relaxed">
          围绕「一区二区三区」提供最全面的分区说明与实用指南，帮助您快速了解一区二区三区的划分标准、核心差异及使用场景，助您精准定位所需内容，节省时间，提升效率。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/zone-1"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            开始探索一区
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/article/zone-comparison-guide"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-background-50/10 backdrop-blur-sm border border-background-50/30 text-background-50 font-medium text-sm hover:bg-background-50/20 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            查看分区对比
            <i className="ri-scales-3-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}